import CancelablePromise, { cancelable } from "cancelable-promise";
import Semaphore from "semaphore-promise";

export type ReleaseLock = () => void;

export function acquireCancelableSemaphore(semaphore: Semaphore): CancelablePromise<ReleaseLock> {
    return cancelable(semaphore.acquire()).then((release) => {
        return new CancelablePromise( (resolve,reject,onCancel)  => {
            onCancel(() => {
                release();
            });
            resolve(release);

        })
    });
    
}